module.exports = "<article>\r\n    <nav data-ebus-sidebar></nav><section data-ui-view=\"content\" class=\"general-content\"></section>\r\n</article>\r\n";